import { Spinner } from "@chakra-ui/react";

const Loading = () => {
  return <Spinner color="headline.400" />;
};
export default Loading;
